"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateTickAll = exports.updateAll = exports.removeDead = exports.killAll = exports.kill = exports.moveToXY = exports.create = exports.shootAtCrew = exports.shootAtTile = exports.shootAt = exports.getAll = exports.MBulletFrame = void 0;
var diveSlashEffect_sidecar_1 = require("@dive/effects/diveSlashEffect-sidecar");
var diveSplatters_sidecar_1 = require("@dive/effects/diveSplatters-sidecar");
var diveEnums_1 = require("@dive/enums/diveEnums");
var diveSimulationManager_sidecar_1 = require("@dive/simulation/diveSimulationManager-sidecar");
var spritesCrew_1 = require("@dive/spriteRecyclers/spritesCrew");
var diveTilemap_sidecar_1 = require("@dive/tilemap/diveTilemap-sidecar");
var entitiesUtils_sidecar_1 = require("@entities/entitiesUtils-sidecar");
var angleUtil_sidecar_1 = require("@lib/angleUtil-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var distanceUtil_sidecar_1 = require("@lib/distanceUtil-sidecar");
var imports_1 = require("@lib/imports");
var mathUtils_sidecar_1 = require("@lib/mathUtils-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var diveCrew_misc_sidecar_1 = require("@voyage/crew/diveCrew_misc-sidecar");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var voyageMessageCrewHurt_1 = require("@voyage/multi/voyageMessageCrewHurt");
exports.MBulletFrame = {
    none: sprites_sidecar_1.sprites.diveEffectsAbilityNull,
    fireball: sprites_sidecar_1.sprites.diveEffectsBulletFireball,
    arrow: sprites_sidecar_1.sprites.diveEffectsBulletArrow,
    bullet: sprites_sidecar_1.sprites.diveEffects2BulletBullet,
};
var objs = [];
function getAll() {
    return objs;
}
exports.getAll = getAll;
// TODO: just combine this with create?
function shootAt(tracking, team, data, start, end, targetCrewId) {
    // let ox = dx * lead
    // let oy = dy * lead
    if (tracking === diveEnums_1.EDiveBulletTracking.Tile) {
        return shootAtTile(team, data, start, end);
    }
    if (tracking === diveEnums_1.EDiveBulletTracking.Crew) {
        return shootAtCrew(team, data, start, end, targetCrewId);
    }
    assert_sidecar_1.assert.failed('unknown tracking type', tracking);
}
exports.shootAt = shootAt;
function shootAtTile(team, data, start, end) {
    // let ox = dx * lead
    // let oy = dy * lead
    var id = diveSimulationManager_sidecar_1.diveSimulationManager.synced_createId();
    var obj = create(id, start, end, 0, data.damage, data.damageType, data.hitEffect, data.bulletFrame);
    return obj;
}
exports.shootAtTile = shootAtTile;
function shootAtCrew(team, data, start, end, targetCrewId) {
    // let ox = dx * lead
    // let oy = dy * lead
    var id = diveSimulationManager_sidecar_1.diveSimulationManager.synced_createId();
    var obj = create(id, start, end, targetCrewId, data.damage, data.damageType, data.hitEffect, data.bulletFrame);
    return obj;
}
exports.shootAtCrew = shootAtCrew;
function create(id, 
// data: IDiveCrewWeaponData,
start, end, targetCrewId, damage, damageType, hitEffect, bulletFrame) {
    id = diveSimulationManager_sidecar_1.diveSimulationManager.synced_createId(id);
    var dist = distanceUtil_sidecar_1.distanceUtil.distanceNormalIIJ(start, end);
    // TODO: allow this to be set based on weapon
    var timeToLiveTicks = Math.floor(dist * 3.5);
    if (timeToLiveTicks < 5) {
        timeToLiveTicks = 5;
    }
    // let rot = angleUtil.calcAngleToIJ(start, end)
    // let dx = Math.cos(rot)
    // let dy = Math.sin(rot)
    var tp = diveTilemap_sidecar_1.diveTilemap.getSafeIIJ(start);
    assert_sidecar_1.assert.notNil(tp);
    var obj = {
        id: id,
        idLoaded: -1,
        isDead: false,
        eType: 'voy-misc',
        // data,
        damage: damage,
        damageType: damageType,
        hitEffect: hitEffect,
        x: tp.x,
        y: tp.y,
        team: 0,
        // rotation: rot,
        // dx: dx,
        // dy: dy,
        start: distanceUtil_sidecar_1.distanceUtil.cloneIJ(start),
        end: distanceUtil_sidecar_1.distanceUtil.cloneIJ(end),
        targetCrewId: targetCrewId,
        tickCount: 0,
        timeToLiveTicks: timeToLiveTicks,
        bulletFrame: bulletFrame,
        // firedFromId: msg.firedCrewId,
    };
    objs.push(obj);
    // moveToXY(obj, obj.x, obj.y)
    // TODO: sfx
    // if (obj.team === 0) {
    //   voyageSounds.playShootCrewGun()
    // } else {
    //   voyageSounds.playShootAlienGun()
    // }
    return obj;
}
exports.create = create;
function moveToXY(obj, x, y) {
    obj.x = x;
    obj.y = y;
}
exports.moveToXY = moveToXY;
function kill(obj) {
    obj.isDead = true;
}
exports.kill = kill;
function killAll() {
    imports_1.l.forEach(objs, function (c) {
        kill(c);
    });
    removeDead();
}
exports.killAll = killAll;
function removeDead() {
    entitiesUtils_sidecar_1.entitiesUtils.removeDead(objs, function (c) { });
}
exports.removeDead = removeDead;
function updateAll() {
    imports_1.l.forEach(objs, function (c) {
        update(c);
    });
}
exports.updateAll = updateAll;
function updateTickAll() {
    imports_1.l.forEach(objs, function (c) {
        updateTick(c);
    });
    removeDead();
}
exports.updateTickAll = updateTickAll;
function update(obj) {
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    if (obj.isDead) {
        return;
    }
    var target = diveCrew_sidecar_1.diveCrew.findByIdSafe(obj.targetCrewId);
    var frame = exports.MBulletFrame[obj.bulletFrame || exports.MBulletFrame.none][0];
    var partialTick = diveSimulationManager_sidecar_1.diveSimulationManager.getPartialTick(); //* 0 // 0.25
    var t = (obj.tickCount + partialTick) / (obj.timeToLiveTicks || 1);
    t = mathUtils_sidecar_1.mathUtils.clamp1(t);
    var sxy = diveTilemap_sidecar_1.diveTilemap.convertIIJtoXY(obj.start);
    var targetX = 0;
    var targetY = 0;
    var rotation = 0;
    if (target) {
        rotation = angleUtil_sidecar_1.angleUtil.calcAngleToXY(sxy, target);
        // let dx = Math.cos(rotation)
        // let dy = Math.sin(rotation)
        targetX = target.x;
        targetY = target.y;
        moveToXY(obj, mathUtils_sidecar_1.mathUtils.lerp(sxy.x, targetX, t), mathUtils_sidecar_1.mathUtils.lerp(sxy.y, targetY, t));
    }
    if (!target) {
        rotation = angleUtil_sidecar_1.angleUtil.calcAngleToIJ(obj.start, obj.end);
        // let dx = Math.cos(rotation)
        // let dy = Math.sin(rotation)
        var txy = diveTilemap_sidecar_1.diveTilemap.convertIIJtoXY(obj.end);
        targetX = txy.x;
        targetY = txy.y;
        moveToXY(obj, mathUtils_sidecar_1.mathUtils.lerp(sxy.x, targetX, t), mathUtils_sidecar_1.mathUtils.lerp(sxy.y, targetY, t));
    }
    var img = spritesCrew_1.spritesCrew.getNext(obj.x, obj.y, frame);
    img.rotation = rotation;
}
function updateTick(obj) {
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    if (obj.isDead) {
        return;
    }
    var targetCrew = null;
    if (obj.targetCrewId) {
        targetCrew = diveCrew_sidecar_1.diveCrew.findByIdSafe(obj.targetCrewId);
        if (targetCrew && diveCrew_sidecar_1.diveCrew.isDeadish(targetCrew)) {
            targetCrew = null;
        }
        if (targetCrew) {
            obj.end = { i: targetCrew.i, j: targetCrew.j };
        }
    }
    // TODO: dynamic ttl
    obj.tickCount++;
    if (obj.tickCount > obj.timeToLiveTicks) {
        // Show hit
        var effect = diveSlashEffect_sidecar_1.diveSlashEffect.create(obj.hitEffect);
        diveSlashEffect_sidecar_1.diveSlashEffect.moveToIIJ(effect, obj.end);
        var targetHit = targetCrew;
        if (!targetHit) {
            targetHit = diveCrew_sidecar_1.diveCrew.getAtIIJ(obj.end);
        }
        if (targetHit) {
            // TODO: add in attacker id
            diveCrew_sidecar_1.diveCrew.hurt(targetHit, obj.damage, obj.damageType, 0);
            if (obj.damageType === voyageMessageCrewHurt_1.EVoyageCrewDamageType.Pierce) {
                // Add blood effects
                var splatterTint = diveCrew_misc_sidecar_1.diveCrew_misc.getSplatterTint(targetHit);
                var splatterType = diveCrew_misc_sidecar_1.diveCrew_misc.getSplatterType(targetHit);
                if (splatterType !== diveEnums_1.EDiveSplatterType.None) {
                    diveSplatters_sidecar_1.diveSplatters.createMultiple(splatterType, 1, targetHit.i, targetHit.j, targetHit.x, targetHit.y, splatterTint);
                }
            }
        }
        kill(obj);
    }
}
